import {SelectData} from 'mui-rff';

export const transformCatalog = (dataCat: any[], labelProp: string, valueProp: string, stringValue: boolean = false): SelectData[] => {
	return dataCat.map((data: any) => {
		const formattedData: SelectData = {
			label: data[labelProp],
			value: (!stringValue) ? data[valueProp] : `${data[valueProp]}`,
		};

		return formattedData;
	});
};

export const transformCatalogKey = (dataCat: any[], labelProp: string, valueProp: string, concatProp: string): SelectData[] => {
	return dataCat.map((data: any) => {
		const formattedData: SelectData = {
			label: data[concatProp] + " - " + data[labelProp],
			value: data[valueProp],
		};

		return formattedData;
	});
};

export const transformCatalogDisabled = (dataCat: any[], labelProp: string, valueProp: string): SelectData[] => {
	return dataCat.map((data: any) => {
		const formattedData: SelectData = {
			label: data[labelProp],
			value: data[valueProp],
			disabled: false,
		};

		return formattedData;
	});
};

export const transformCatalogRadio = (dataCat: any[], labelProp: string, valueProp: string): any[] => {
	return dataCat.map((data: any) => {
		const formattedData: any = {
			label: data[labelProp],
			value: data[valueProp],
		};

		return formattedData;
	});
};

export const concatSelectData = (original: SelectData[], values: SelectData[]): SelectData[] => {
	return original.concat(values);
};

export const concatRadioData = (original: any[], values: any[]): any[] => {
	return original.concat(values);
};

export const findValueInCatalog = (dataCat: any[], valueProp: any): any => {
	let initialValues = {};
	if (dataCat.length > 0) {
		dataCat.forEach((item) => {
			if( item.value === valueProp ){
				initialValues = item;
			}
		});
	}
	return initialValues;
};

export const transformCatalogMultiple = (dataCat: any[], labelProp1: string, labelProp2: string, valueProp: string): SelectData[] => {
	return dataCat.map((data: any) => {
		const formattedData: SelectData = {
			label: `${data[labelProp1]} - ${data[labelProp2]}`,
			value: data[valueProp],
		};

		return formattedData;
	});
};